import * as React from 'react';
import styled from 'styled-components';
import { rem, darken } from 'polished';
import {
  getProductDefaultInfo,
  getProductSmallInfo,
} from '../../../../utilities/selectors';
import {
  getSanitasProductDefaultInfo,
  getZemplinTrueCountFromNormalCount,
} from '../../selectors';
import {
  FlexRowCenterHorizontal,
  FlexRow,
  FlexRowCenterVertical,
} from '../../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../../Defaults/Text';
import { prop } from '../../../../utilities';
import { PriceInfo } from './PriceInfo';
import { __ } from 'react-i18n';

export interface Props {
  product: any;
  count: number;
  isPriceWithVat: boolean;
  goodId: number;
}

function AddedToCartProduct({
  product,
  count,
  isPriceWithVat = true,
  goodId,
}: Props) {
  const { currency } = getProductDefaultInfo(product);
  const { name } = getProductDefaultInfo(product);
  const { picture } = getProductSmallInfo(product);
  const { unit, priceWithoutVat } = getSanitasProductDefaultInfo(product);
  let { price } = getSanitasProductDefaultInfo(product);

  const goodPrice = product.goods.filter(
    (good: any) => good.good_id === goodId,
  );
  const gPrice = prop(goodPrice, '0.unitprice', 0);

  if (goodPrice.length && gPrice) {
    price = gPrice;
  }

  const trueCount = getZemplinTrueCountFromNormalCount(unit === 'Mks', count);
  const correctPrice = isPriceWithVat ? price : priceWithoutVat;

  return (
    <Wrapper>
      <DesktopWrapper>
        {' '}
        <NameWrapper>
          <Image alt={`Obrázok ku produktu ${name}`} src={picture} />
          <Name>{name}</Name>
        </NameWrapper>
        <PriceWrapper>
          <Package>{`${trueCount} ${unit}`}</Package>
          <PriceInfo
            price={(correctPrice * trueCount).toFixed(2)}
            currency={currency}
          />
        </PriceWrapper>
      </DesktopWrapper>
      <MobileWrapper>
        <Image alt={`Obrázok ku produktu ${name}`} src={picture} />
        <NameWrapper>
          <Name>{name}</Name>
          <PriceWrapper>
            <Package>{`${trueCount} ${unit}`}</Package>
            <PriceInfo
              price={(correctPrice * trueCount).toFixed(2)}
              currency={currency}
            />
          </PriceWrapper>
        </NameWrapper>
      </MobileWrapper>
    </Wrapper>
  );
}

const Wrapper = styled(FlexRowCenterVertical)`
  justify-content: space-between;
  width: 100%;
  padding: ${rem(24)};
  ${({ theme }) => theme.mediab.m600`
    flex-flow: column;
    align-items: flex-start;
    margin-bottom: 0;
    padding: ${rem(16)};
  `}
`;

const PriceWrapper = styled(FlexRowCenterHorizontal)``;

const NameWrapper = styled(FlexRow)`
  align-items: center;
  ${({ theme }) => theme.mediab.m600`
   width: 65%;
  `};
  ${({ theme }) => theme.mediab.m600`
    flex-flow: column;
    align-items: flex-start;
`}
`;

const Image = styled.img`
  width: ${rem(48)};
  height: ${rem(48)};
  margin-right: ${rem(16)};
`;

const Name = styled(TextP)`
  font-size: ${rem(16)};
  line-height: 1.2;
  margin-bottom: ${rem(4)};

  color: ${({ theme }) => theme.colors.black};
  text-align: left;
  font-family: ${({ theme }) => theme.font.primary};
  font-weight: 400;
  max-width: 80%;
  transition: color 0.2s;

  &:hover {
    color: ${({ theme }) => darken(0.15, theme.colors.primary)};
  }

  ${({ theme }) => theme.mediab.l1300`
      max-width: ${rem(340)};
  `}

  ${({ theme }) => theme.mediab.l1150`
      max-width: ${rem(300)};
  `}
  ${({ theme }) => theme.mediab.m600`
    font-size: ${rem(14)};
    line-height: 1.2;
    max-width: initial;
    white-space: normal;
    text-overflow: initial;
    overflow: initial;
    height: initial;
    margin-bottom: 0;
  `}
`;

const Price = styled(TextP)`
  font-size: ${rem(16)};
  line-height: ${rem(28)};
  margin-left: ${rem(8)};
  font-weight: 700;
  font-weight: 400;
  ${({ theme }) => theme.mediab.m600`
  font-size: ${rem(14)};
  `}
`;

const Package = styled(Price)`
  margin-right: ${rem(16)};
  color: ${({ theme }) => theme.colors.black};
  font-size: ${rem(16)};
  font-weight: 400;
  ${({ theme }) => theme.mediab.m600`
    margin-left: 0;
    margin-right: ${rem(8)};
    font-size: ${rem(14)};
  `}
  white-space: nowrap;
`;
const DesktopWrapper = styled.div`
  ${({ theme }) => theme.mediab.m600`
      display: none;
    `}
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;
const MobileWrapper = styled.div`
  display: none;
  ${({ theme }) => theme.mediab.m600`
      display: flex;
  `}
`;

export { AddedToCartProduct };
